import { useEffect, useState } from 'react';
import { API } from '../../services/api/api.service';
import { ProductIdType, ProductType, ProductWithoutPriceType } from '../../types';
import { adaptProductsPriceToClient, adaptProductsToClient } from '../../utils/adapters/adaptersToClient';

const useFetchProductData = (productsId: ProductIdType[]): ProductType[] | null => {
  const [data, setData] = useState<ProductType[] | null>(null);

  useEffect(() => {
    const api = new API();
    const productsPromise = api.getProducts(productsId);
    const pricesPromise = api.getPrices(productsId);

    Promise.all([productsPromise, pricesPromise])
      .then(([products, prices]) => {
        const adaptProducts = adaptProductsToClient(products);
        const adaptPrices = adaptProductsPriceToClient(prices);
        const result: ProductType[] = [];

        adaptProducts.forEach((product: ProductWithoutPriceType): void => {
          const priceId = adaptPrices.find(
            (price) => price.productId === product.productId
          );

          if (priceId) {
            result.push({
              ...product,
              price: {
                basePrice: priceId.basePrice,
                salePrice: priceId.salePrice,
                productId: priceId.productId,
              },
            });
          } else {
            result.push({
              ...product,
              price: {
                basePrice: null!,
                salePrice: null!,
                productId: product.productId,
              },
            });
          }
        });

        setData(result);
      })
      .catch((error) => {
        console.error('Failed to fetch data:', error);
      });

    return () => {
      setData(null);
    };
  }, [productsId]);

  return data;
};

export default useFetchProductData;